import {type FromSchema} from 'json-schema-to-ts'

export const brandedItemContentChangeNotification = {
  $id: 'http://example.com/example.json',
  type: 'object',
  title: 'The root schema',
  description: 'The root schema comprises the entire JSON document.',
  default: {},
  examples: [
    {
      NotificationVersion: '1.0',
      NotificationType: 'BRANDED_ITEM_CONTENT_CHANGE',
      PayloadVersion: '1.0',
      EventTime: '2019-03-20T18:59:30.194Z',
      Payload: {
        MarketplaceId: 'ATVPDKIKX0DER',
        BrandName: 'Great Brand',
        Asin: 'B1234567',
        AttributesChanged: [
          'bullet_point',
          'item_name',
          'product_description',
          'main_product_image_locator',
          'other_product_image_locator_1',
          'other_product_image_locator_2',
          'other_product_image_locator_3',
          'other_product_image_locator_4',
          'other_product_image_locator_5',
          'other_product_image_locator_6',
          'other_product_image_locator_7',
          'other_product_image_locator_8',
          'swatch_product_image_locator',
        ],
      },
      NotificationMetadata: {
        ApplicationId: 'amzn1.sellerapps.app.f1234566-aaec-55a6-b123-bcb752069ec5',
        SubscriptionId: '93b098e1-c42-2f45-93a1-78910a6a8369',
        PublishTime: '2019-03-20T18:59:48.768Z',
        NotificationId: '8e009934-da2c-4f9c-9bc7-93f23b7e1f60',
      },
    },
  ],
  required: [
    'NotificationVersion',
    'NotificationType',
    'PayloadVersion',
    'EventTime',
    'Payload',
    'NotificationMetadata',
  ],
  properties: {
    NotificationVersion: {
      $id: '#/properties/NotificationVersion',
      type: 'string',
      title: 'The NotificationVersion schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['1.0'],
    },
    NotificationType: {
      $id: '#/properties/NotificationType',
      type: 'string',
      title: 'The NotificationType schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['BRANDED_ITEM_CONTENT_CHANGE'],
    },
    PayloadVersion: {
      $id: '#/properties/PayloadVersion',
      type: 'string',
      title: 'The PayloadVersion schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['1.0'],
    },
    EventTime: {
      $id: '#/properties/EventTime',
      type: 'string',
      title: 'The EventTime schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['2019-03-20T18:59:30.194Z'],
    },
    Payload: {
      $id: '#/properties/Payload',
      type: 'object',
      title: 'The Payload schema',
      description: 'An explanation about the purpose of this instance.',
      default: {},
      examples: [
        {
          MarketplaceId: 'ATVPDKIKX0DER',
          BrandName: 'Great Brand',
          Asin: 'B1234567',
          AttributesChanged: [
            'bullet_point',
            'item_name',
            'product_description',
            'main_product_image_locator',
            'other_product_image_locator_1',
            'other_product_image_locator_2',
            'other_product_image_locator_3',
            'other_product_image_locator_4',
            'other_product_image_locator_5',
            'other_product_image_locator_6',
            'other_product_image_locator_7',
            'other_product_image_locator_8',
            'swatch_product_image_locator',
          ],
        },
      ],
      required: ['MarketplaceId', 'BrandName', 'Asin', 'AttributesChanged'],
      properties: {
        MarketplaceId: {
          $id: '#/properties/Payload/properties/MarketplaceId',
          type: 'string',
          title: 'The MarketplaceId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['ATVPDKIKX0DER'],
        },
        BrandName: {
          $id: '#/properties/Payload/properties/BrandName',
          type: 'string',
          title: 'The BrandName schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['Great Brand'],
        },
        Asin: {
          $id: '#/properties/Payload/properties/Asin',
          type: 'string',
          title: 'The Asin schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['B1234567'],
        },
        AttributesChanged: {
          $id: '#/properties/Payload/properties/AttributesChanged',
          type: 'array',
          items: {
            type: 'string',
          },
          title: 'Changed item attributes',
          description:
            "The array of item attributes which changed. Possible values include bullet_point, item_name, product_description, and image-related attributes shown in the examples. NOTE: the attributes that contain the word 'image' all mean the same thing right now, which is that one or more images changed on the product detail page. In a future release we may update them to mean that individual image attribute changed, but for now if any image changes all the image attributes will be present in the notification. Attribute names, descriptions, and requirements are available in the Product Type Definitions API.",
          examples: [
            ['bullet_point', 'item_name', 'product_description'],
            [
              'main_product_image_locator',
              'other_product_image_locator_1',
              'other_product_image_locator_2',
              'other_product_image_locator_3',
              'other_product_image_locator_4',
              'other_product_image_locator_5',
              'other_product_image_locator_6',
              'other_product_image_locator_7',
              'other_product_image_locator_8',
              'swatch_product_image_locator',
            ],
          ],
        },
      },
      additionalProperties: true,
    },
    NotificationMetadata: {
      $id: '#/properties/NotificationMetadata',
      type: 'object',
      title: 'The NotificationMetadata schema',
      description: 'An explanation about the purpose of this instance.',
      default: {},
      examples: [
        {
          ApplicationId: 'amzn1.sellerapps.app.f1234566-aaec-55a6-b123-bcb752069ec5',
          SubscriptionId: '93b098e1-c42-2f45-93a1-78910a6a8369',
          PublishTime: '2019-03-20T18:59:48.768Z',
          NotificationId: '8e009934-da2c-4f9c-9bc7-93f23b7e1f60',
        },
      ],
      required: ['ApplicationId', 'SubscriptionId', 'PublishTime', 'NotificationId'],
      properties: {
        ApplicationId: {
          $id: '#/properties/NotificationMetadata/properties/ApplicationId',
          type: 'string',
          title: 'The ApplicationId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['amzn1.sellerapps.app.f1234566-aaec-55a6-b123-bcb752069ec5'],
        },
        SubscriptionId: {
          $id: '#/properties/NotificationMetadata/properties/SubscriptionId',
          type: 'string',
          title: 'The SubscriptionId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['93b098e1-c42-2f45-93a1-78910a6a8369'],
        },
        PublishTime: {
          $id: '#/properties/NotificationMetadata/properties/PublishTime',
          type: 'string',
          title: 'The PublishTime schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['2019-03-20T18:59:48.768Z'],
        },
        NotificationId: {
          $id: '#/properties/NotificationMetadata/properties/NotificationId',
          type: 'string',
          title: 'The NotificationId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['8e009934-da2c-4f9c-9bc7-93f23b7e1f60'],
        },
      },
      additionalProperties: true,
    },
  },
  additionalProperties: true,
} as const

export type BrandedItemContentChangeNotification = FromSchema<
  typeof brandedItemContentChangeNotification
>
